import { formatTaxId } from '../../utils/taxIdUtils';

/**
 * Uma PARTE da dívida numa célula de tabela: nome em cima, documento embaixo.
 *
 * Três partes diferentes usam este mesmo desenho, e é a coluna que as distingue — não o formato:
 *
 *   Emitente / Cedente   quem ORIGINOU a dívida (participante primário da operação)
 *   Devedor              quem a DEVE (o sacado do título)
 *   Pagador              quem a PAGOU (na tela de Pagamentos)
 *
 * Numa CPRF comum as três coincidem, e é por isso que a confusão é silenciosa: elas divergem
 * exatamente na cessão, que é quando alguém abre a tela para entender de quem é aquela dívida.
 *
 * Mora em `molecules/` pelo mesmo motivo do [CommentCell]: a tela de Títulos, a de Faturas e o
 * modal de faturas do pagamento mostram as MESMAS colunas, e importar de um modal para dentro de
 * uma página já derrubou a página inteira com "Element type is invalid".
 *
 * O `truncate` com o nome no `title` não é enfeite: razão social de agro é longa, e sem o teto ela
 * empurra as colunas de valor para fora da tela.
 */
const PartyCell: React.FC<{
    name?: string | null;
    documentNumber?: string | null;
    /** teto do nome; o padrão casa com as colunas das telas de cobrança */
    maxWidthClass?: string;
}> = ({ name, documentNumber, maxWidthClass = 'max-w-[180px]' }) => {
    if (!name) return <span className="text-gray-400">-</span>;
    return (
        <div>
            <div className={`font-medium truncate ${maxWidthClass}`} title={name}>{name}</div>
            {documentNumber && (
                <div className="text-xs text-gray-500">{formatTaxId(documentNumber)}</div>
            )}
        </div>
    );
};

export default PartyCell;
